import IconLocation from 'common/Icons/Home/IconLocation';
import IconPatient from 'common/Icons/Home/IconPatient';
import IconProvider from 'common/Icons/Home/IconProvider';
import IconVerified from 'common/Icons/Home/IconVerified';
import SubtextLarge from 'common/SubtextLarge';

import IconCalendar from '../../../common/Icons/Home/IconCalendar';
import HeadingHome from 'common/HeadingHome';
import { HomePageIds } from 'common/constant';

const WhyBeSeen = () => {
    const howItWorksSteps = [
        {
            id: 1,
            icon: <IconCalendar />,
            description: 'Providers enroll, add services, prices, and availability',
        },
        { id: 2, icon: <IconPatient />, description: 'Be:Seen attracts new patients with digital advertising' },
        {
            id: 3,
            icon: <IconLocation />,
            description: 'Patients find nearby health services via Be:Seen homepage or app',
        },
        {
            id: 4,
            icon: <IconProvider />,
            description: 'Be:Seen brings together nearby patients and providers',
        },
        {
            id: 5,
            icon: <IconVerified />,
            description: 'Be:Seen quickly and securely facilitates booking and payments',
        },
    ];

    return (
        <div className="flex flex-col items-center p-8 md:py-8 md:px-12 md:pb-[140px] lg:py-16 lg:px-28 lg:pb-[140px] gap-4 md:gap-16 bg-[#F5F1ED] font-['Poppins']">
                <div className="flex justify-center items-center flex-wrap md:flex-nowrap gap-8 md:gap-20 lg:gap-36 w-full xl:w-[90%] max-w-[1100px]" id={HomePageIds.whyBeSeen}>
                    <HeadingHome className="text-center md:text-left">Why use Be:Seen?</HeadingHome>

                    <div className="flex flex-col w-[80%] max-w-[660px]">
                        <HeadingHome className="opacity-20 text-center md:text-left">100%</HeadingHome>
                        <SubtextLarge className="text-center md:text-left">
                            100% Focus on what matters most. No audits. No claims. Consistent payments.
                        </SubtextLarge>
                    </div>

                    <div className="flex flex-col w-[80%] max-w-[660px]">
                        <HeadingHome className="opacity-20 text-center md:text-left">10 Days</HeadingHome>
                        <SubtextLarge className="text-center md:text-left">Beat insurance payouts and get paid in 10-30 days instead of 45-90. </SubtextLarge>
                    </div>
                </div>

            <div className="flex flex-col justify-center items-center gap-4 md:gap-16 pt-4 md:pt-16" id={HomePageIds.howItWorks}>
                <HeadingHome className="text-center pt-[60px] md:pt-0">How it works...</HeadingHome>
                <div className="flex flex-col gap-8 md:gap-12 w-full md:w-[85%]">
                    {howItWorksSteps.map((step, index) => (
                        <div className="relative flex gap-7 items-center" key={index}>
                            {/* Hide icon on small screens */}
                            <div className="hidden sm:block">{step.icon}</div>

                            {/* Hide border on small screens */}
                            {index !== howItWorksSteps.length - 1 && (
                                <div className="hidden sm:block h-[50px] border-dotted border-l-2 border-[#95CFD3] absolute top-full left-[2%]"></div>
                            )}

                            <div className="flex flex-col">
                                <span className="text-[#95CFD3] text-base font-bold">STEP {index + 1}</span>
                                <span className="text-2xl font-bold text-[#3E3E4A]"> {step.description}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default WhyBeSeen;
